import ReactMarkdown from "react-markdown";

interface CompactMarkdownProps {
  content: string;
  className?: string;
}

/** Dense typography for cards and panels (e.g. med chron summary highlight fields). */
export const CompactMarkdown = ({ content, className = "" }: CompactMarkdownProps) => {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          h1: ({ ...props }) => (
            <h1
              className="mb-2 mt-3 text-lg font-bold tracking-tight text-neutral-900 first:mt-0"
              {...props}
            />
          ),
          h2: ({ ...props }) => (
            <h2
              className="mb-1.5 mt-2.5 text-base font-bold tracking-tight text-neutral-900 first:mt-0"
              {...props}
            />
          ),
          h3: ({ ...props }) => (
            <h3 className="mb-1 mt-2 text-sm font-bold text-neutral-900" {...props} />
          ),
          p: ({ ...props }) => (
            <p
              className="mb-1.5 whitespace-pre-wrap text-dense font-medium leading-[1.55] text-neutral-800 last:mb-0"
              {...props}
            />
          ),
          ul: ({ ...props }) => (
            <ul
              className="mb-2 ml-4 list-disc space-y-1 text-dense font-medium leading-[1.55] text-neutral-800 last:mb-0"
              {...props}
            />
          ),
          ol: ({ ...props }) => (
            <ol
              className="mb-2 ml-4 list-decimal space-y-1 text-dense font-medium leading-[1.55] text-neutral-800 last:mb-0"
              {...props}
            />
          ),
          li: ({ ...props }) => <li {...props} />,
          strong: ({ ...props }) => <strong className="font-bold text-neutral-900" {...props} />,
          em: ({ ...props }) => <em className="text-neutral-600" {...props} />,
          hr: () => <hr className="my-2 border-neutral-100" />,
        }}
      >
        {content.replace(/\\n/g, "\n")}
      </ReactMarkdown>
    </div>
  );
};
